/**
 * imgix 图片 URL 归一化工具
 *
 * 背景：上游 Product Hunt 的 imgix URL 形态不统一——
 *   - 部分不含 w/h 参数（如 ?auto=format&fit=crop）
 *   - 部分含 w/h 但顺序乱（如 &h=220&w=293）或被 frame=1 隔开
 * 若仅用正则替换 w=\d+&h=\d+，对上面这些形态经常匹配不到，
 * 导致卡片缩略图与灯箱大图都回退成同一张原图。
 * 这里统一做法：先剔除已有 w/h/fit/dpr，再按需追加目标尺寸，
 * 保证无论原 URL 长什么样，小图/大图都能正确分离。
 */

/**
 * 把任意 imgix URL 归一化为指定尺寸的 URL
 * @param {string} url 原始图片 URL
 * @param {number} w 目标宽度
 * @param {number} h 目标高度
 * @returns {string} 归一化后的 URL（fit=crop & dpr=2）
 */
export function normalizedImgix(url, w, h) {
  if (!url) return '';
  // 剔除已有的缩放相关参数（顺序/是否夹 frame=1 都不影响）
  let u = url.replace(/(?:[?&])(?:w=\d+|h=\d+|fit=[^&]*|dpr=\d+)/g, '');
  // 清理剔除后可能留下的 ?& / && / 尾部 &?
  u = u.replace(/\?&/, '?').replace(/&{2,}/g, '&').replace(/[?&]$/, '');
  const sep = u.includes('?') ? '&' : '?';
  return `${u}${sep}w=${w}&h=${h}&fit=crop&dpr=2`;
}

// 卡片缩略图（约 368×220，dpr=2 → 设备像素 736×440）
export function formatImageUrlsm(url) {
  return normalizedImgix(url, 368, 220);
}

// 灯箱大图（约 1100×619，dpr=2 → 设备像素 2200×1238）
export function formatImageUrl(url) {
  return normalizedImgix(url, 1100, 619);
}

export default { normalizedImgix, formatImageUrl, formatImageUrlsm };
